import { Injectable } from '@angular/core';
import {
  HttpClient,
} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { DocumentGroup, DocumentGroupVersion } from '../models/documentGroup';
import { Document } from '../models/document';

@Injectable({
  providedIn: 'root',
})
export class DocumentGroupService {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getById(groupId: string): Promise<DocumentGroup> {
    return firstValueFrom(
      this.http.get<DocumentGroup>(
        `${environment.backend}/documents/group/${groupId}`,
      ),
    );
  }

  listVersions(groupId: string): Promise<DocumentGroupVersion[]> {
    return firstValueFrom(
      this.http.get<DocumentGroupVersion[]>(
        `${environment.backend}/documents/group/${groupId}/versions`,
      ),
    );
  }

  getCurrentDocumentVersion(groupId: string): Promise<Document> {
    return firstValueFrom(
      this.http.get<Document>(
        `${environment.backend}/documents/group/${groupId}/current`,
      ),
    );
  }
}
